import { SUPPORT_EMAIL } from '../config';
import { STORE_LINKS, type StorePlatform } from './storeLinks';

export const supportMailto = (subject: string): string =>
  `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(subject)}`;

// Same pages as the banner, Android tagged `web-modal` so the two entry points are told apart.
export const APP_MODAL_STORE_LINKS: Record<StorePlatform, string> = {
  ios: STORE_LINKS.ios,
  android: STORE_LINKS.android.replace('utm_source%3Dweb-banner', 'utm_source%3Dweb-modal'),
};
